import { createReducer } from "../../../common/reduxUtil";
import {
  GMAT_SET_CATALOG,
  GMAT_SET_LOAD_ERROR,
  GMAT_CATALOG_REQUESTED,
  GMAT_SET_ATTEMPT_STARTING,
} from "./types";

const initialState = {
  catalog: null,
  loadError: "",
  request: 0,
  attemptStarting: false,
};

export default createReducer(initialState, {
  [GMAT_SET_CATALOG]: (state, catalog) => ({ ...state, catalog }),
  [GMAT_SET_LOAD_ERROR]: (state, loadError) => ({ ...state, loadError }),
  [GMAT_CATALOG_REQUESTED]: (state) => ({
    ...state,
    request: state.request + 1,
  }),
  [GMAT_SET_ATTEMPT_STARTING]: (state, attemptStarting) => ({
    ...state,
    attemptStarting,
  }),
});
